import type React from "react";
import Layout from "../../../components/site/Layout/Layout";
import { Link } from "react-router-dom";

const PrivacyPolicyPage: React.FC = () => {
	return (
		<Layout>
			<div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
				<h1 className="text-3xl font-bold mb-8">プライバシーポリシー</h1>

				<div className="prose prose-purple max-w-none">
					<p className="text-gray-600 mb-8">
						大船渡学習ギルド（以下、「当団体」といいます。）は、本ウェブサイトで提供するサービス（以下、「本サービス」といいます。）における、ユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下、「本ポリシー」といいます。）を定めます。
					</p>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">
							1. 個人情報の収集方法
						</h2>
						<p className="text-gray-600 mb-4">
							当団体は、ユーザーが利用登録をする際に氏名、生年月日、住所電話番号、メールアドレスなどの個人情報をお尋ねすることがあります。また、ユーザーと提携先などとの間でなされた取引記録や、決済に関する情報を当団体の提携先（情報提供元、広告主、広告配信先などを含みます。以下、｢提携先｣といいます。）などから収集することがあります。
						</p>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">
							2. 個人情報を収集・利用する目的
						</h2>
						<p className="text-gray-600 mb-4">
							当団体が個人情報を収集・利用する目的は、以下のとおりです。
						</p>
						<ul className="list-disc list-inside space-y-2 text-gray-600">
							<li>本サービスの提供・運営のため</li>
							<li>ユーザーからのお問い合わせに回答するため</li>
							<li>
								ユーザーが利用中のサービスの新機能、更新情報、キャンペーン等及び当団体が提供する他のサービスの案内のメールを送付するため
							</li>
							<li>メンテナンス、重要なお知らせなど必要に応じたご連絡のため</li>
							<li>
								利用規約に違反したユーザーや、不正・不当な目的でサビスを利用しようとするユーザーの特定をし、ご利用をお断りするため
							</li>
							<li>
								ユーザーにご自身の登録情報の閲覧や変更、削除、ご利用状況の閲覧を行っていただくため
							</li>
							<li>有料サービスにおける決済のため</li>
							<li>上記の利用目的に付随する目的</li>
						</ul>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">
							3. 個人情報の第三者提供
						</h2>
						<p className="text-gray-600 mb-4">
							当団体は、次に掲げる場合を除いて、あらかじめユーザーの同意を得ることなく、第三者に個人情報を提供することはありません。ただし、個人情報保護法その他の法令で認められる場合を除きます。
						</p>
						<ul className="list-disc list-inside space-y-2 text-gray-600">
							<li>
								人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき
							</li>
							<li>
								公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
							</li>
							<li>
								国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
							</li>
						</ul>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">4. 個人情報の開示</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								当団体は、本人から個人情報の開示を求められたときは、本人に対し、遅滞なくこれを開示します。ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、開示しない決定をした場合には、その旨を遅滞なく通知します。
								<ul className="list-disc list-inside ml-6 space-y-2">
									<li>
										本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合
									</li>
									<li>
										当団体の業務の適正な実施に著しい支障を及ぼすおそれがある場合
									</li>
									<li>その他法令に違反することとなる場合</li>
								</ul>
							</li>
							<li>
								前項の定めにかかわらず、履歴情報および特性情報などの個人情報以外の情報については、原則として開示いたしません。
							</li>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">
							5. 個人情報の訂正および削除
						</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								ユーザーは、当団体の保有する自己の個人情報が誤った情報である場合には、当団体が定める手続きにより、当団体に対して個人情報の訂正、追加または削除（以下、「訂正等」といいます。）を請求することができます。
							</li>
							<li>
								当団体は、ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の訂正等を行うものとします。
							</li>
							<li>
								当団体は、前項の規定に基づき訂正等を行った場合、または訂正等を行わない旨の決定をしたときは、遅滞なく、これをユーザーに通知します。
							</li>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">
							6. 個人情報の利用停止等
						</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								当団体は、本人から、個人情報が利用目的の範囲を超えて取り扱われているという理由、または不正の手段により取得されたものであるという理由により、その利用の停止または消去（以下、「利用停止等」といいます。）を求められた場合には、遅滞なく必要な調査を行います。
							</li>
							<li>
								前項の調査結果に基づき、その請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の利用停止等を行います。
							</li>
							<li>
								当団体は、前項の規定に基づき利用停止等を行った場合、または利用停止等を行わない旨の決定をしたときは、遅滞なく、これをユーザーに通知します。
							</li>
							<li>
								前2項にかかわらず、利用停止等に多額の費用を要する場合その他利用停止等を行うことが困難な場合であって、ユーザーの権利利益を保護するために必要なこれに代わるべき措置をとれる場合は、この代替策を講じるものとします。
							</li>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">
							7. Cookieの使用について
						</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								当団体は、ユーザーの利便性向上のため、Cookieを使用することがあります。Cookieとは、ウェブサイトがユーザーのコンピュータに送信する小さなテキストファイルで、ユーザーのコンピュータのハードディスクに保存されます。
							</li>
							<li>
								当団体は、以下の目的のためにCookieを使用します：
								<ul className="list-disc list-inside ml-6 space-y-2">
									<li>ログイン状態の維持</li>
									<li>ユーザー設定の保存</li>
									<li>利用状況の分析</li>
									<li>サービスの改善</li>
								</ul>
							</li>
							<li>
								ユーザーは、ブラウザの設定によりCookieの受け入れを拒否することができます。ただし、その場合、本サービスの一部の機能が正常に動作しない可能性があります。
							</li>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">8. セキュリティ対策</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								当団体は、個人情報の漏洩、滅失、き損または不正アクセスの防止その他の個人情報の安全管理のために必要かつ適切な措置を講じるものとします。
							</li>
							<li>
								当団体は、個人情報の取扱いの全部または一部を第三者に委託する場合は、当該第三者について厳正な調査を行い、取扱いを委託された個人情報の安全管理が図られるよう、当該第三者に対する必要かつ適切な監督を行います。
							</li>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">
							9. プライバシーポリシーの変更
						</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく、変更することができるものとします。
							</li>
							<li>
								当団体が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。
							</li>
						</ol>
					</section>

					<div className="mt-12 text-gray-600">
						<p>2024年4月1日 制定</p>
					</div>

					<div className="mt-8 p-4 bg-gray-50 rounded-lg">
						<p className="text-sm text-gray-600">
							個人情報の取扱いに関するお問い合わせは、
							<Link
								to="/contact"
								className="text-purple-600 hover:text-purple-500"
							>
								お問い合わせフォーム
							</Link>
							よりご連絡ください。
						</p>
					</div>
				</div>
			</div>
		</Layout>
	);
};

export default PrivacyPolicyPage;
